import type { DesktopBridge } from "@pluck/desktop-bridge";

export function getDesktopBridge(): DesktopBridge | null {
	if (typeof window === "undefined") {
		return null;
	}
	const bridge = window.pluckDesktop;
	return bridge?.isDesktop ? bridge : null;
}

export function isDesktop(): boolean {
	return getDesktopBridge() !== null;
}
